module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: _vm.containerClasses
  }, [_c('figure', {
    staticClass: "spinner__center",
    class: _vm.centerClasses
  }, [_c('span', {
    staticClass: "spinner__anim",
    class: _vm.animClasses
  }), _vm._v(" "), _c('span', {
    staticClass: "spinner__anim spinner__anim--angle",
    class: _vm.animClasses
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ef94f84!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/partials/Spinner.vue
// module id = 733
// module chunks = 1